/*
 * action types
*/

export const REPLACE = "REPLACE_ARCHINGS";
export const CLEAR = "CLEAR_ARCHINGS";
export const CLEAR_ARCHINGS_FILTERS = "CLEAR_ARCHINGS_FILTERS";
export const SET_FILTERS = "SET_ARCHINGS_FILTERS";
export const SET_PAGESIZE = "SET_ARCHINGS_PAGESIZE";
export const SET_PAGENUMBER = "SET_ARCHINGS_PAGENUMBER";
export const DELETE = "DELETE_ARCHING";

/*
 * action creators
*/

export const Replace = (values, totalResults, totalPage) => ({ 
    type : REPLACE,
    closures: values,
    totalResults,
    totalPage
});

export const Clear = () => ({
    type: CLEAR
})

export const SetPageSize = (pageSize) => ({
    type: SET_PAGESIZE,
    pageSize
})

export const SetPageNumber = (pageNumber) => ({
    type: SET_PAGENUMBER,
    pageNumber
})

export const SetFilters = (filters) => ({
    type: SET_FILTERS,
    filters
})

export const Delete = (closure) => ({
    type: DELETE,
    closure
});

export const ClearFilters = () => ({
    type: CLEAR_ARCHINGS_FILTERS,
})